module.exports = __webpack_public_path__ + "media/images/icons/twotone/warning-1cf51ea4bd11de72f942a672cc8da91a.svg";